import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { populateUsers } from '../../redux/ducks/clientDuck';

import Container from '../../components/Container';
import Table from '../../components/Table';
import Text from '../../components/Text';

const columns = [
  { name: 'Correo Electrónico', selector: 'email' },
  { name: 'Nombre', selector: 'name' }
];

function Users({
  clients, populateUsers,
}) {
  useEffect(() => {
    if(!clients[0]) populateUsers();
  }, [clients.length]);

  console.log(clients);

  return (
    <Container className="dashboard-container" bgColor="light">
      <Table
        columns={columns}
        data={clients || []}
        title="Usuarios"
      />
    </Container>
  );
}

function mapStateToProps({ client }) {
  return {
    clients: client.clients,
  }
}

export default connect(
  mapStateToProps, {
    populateUsers,
  }
)(Users);
